import { BillingFormFields } from "../../NormasTeachingCheckout/BillingFormSection.tsx";
import { BonificoBusinessInformation } from "./BonificoOrderDTO.ts";
import {
  isForeignBillingCountry,
  ItalianBillingCountry,
} from "../../MoneyTransfer/billingCountries.ts";

export function toBonificoCustomerTaxCode(
  billing: BillingFormFields,
): string | undefined {
  if (isForeignBillingCountry(billing.address?.country)) return undefined;
  return billing.taxCode?.trim().toUpperCase() || undefined;
}

export function toBonificoBusinessInformation(
  billing: BillingFormFields,
): BonificoBusinessInformation {
  const country = billing.address?.country || ItalianBillingCountry.Italy;
  const isForeignCustomer = isForeignBillingCountry(country);
  return {
    businessName: billing.businessName ?? "",
    businessAddress: {
      street: billing.address?.street ?? "",
      postalCode: billing.address?.cap ?? "",
      city: billing.address?.city ?? "",
      province: billing.address?.province ?? "",
      country,
    },
    vatCode: billing.vat ?? "",
    sdiCode: isForeignCustomer ? undefined : billing.sdiCode || undefined,
    pec: isForeignCustomer ? undefined : billing.pec || undefined,
    businessType:
      billing.businessType as BonificoBusinessInformation["businessType"],
  };
}
